//export default "http://localhost:8000/api";
//export default "https://new.mobilepush.in/api";
export default "/api";
